import PropTypes from 'prop-types';

function Controls({ views, index, setIndex, popinRef, setIsPopinOpen, setViewInPopin }) {
    // Mise en place de la fonction permettant de passer à la vue précédente
    const handlePreviousView = () => {
        if(index === 0) {
            setIndex(views.length - 1);
        } else {
            setIndex(index - 1);
        }
    }

    // Mise en place de la fonction permettant de passer à la vue suivante
    const handleNextView = () => {
        if(index === views.length - 1) {
            setIndex(0);
        } else {
            setIndex(index + 1);
        }
    }

    // Mise en place de la fonction permettant d'ouvrir et de configurer la popin (présent dans <Result />)
    const handleOpenPopin = () => {
        setViewInPopin(views[index].id);
        if(popinRef.current) popinRef.current.showModal();
        setIsPopinOpen(true);
    }

    return (
        <nav className="carousel-controls">
            <button className="button button--dark carousel-controls--popin" onClick={handleOpenPopin}>{views[index].label}</button>
            <div className="carousel-controls--navigation">
                <button className="carousel-controls--button carousel-controls--button-previous" onClick={handlePreviousView}>
                    <svg role="img" id="Arrow_prev" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 29.4 25.3">
                        <title>afficher la vue précédente</title>
                        <path id="Arrow" d="M12.6,0l2.2,2.2L5.8,11.1h23.6v3.1H5.8l8.9,8.9-2.2,2.2L0,12.6,12.6,0"/>
                    </svg>
                </button>
                <div className="carousel-bullets-container">
                    {views.map((view, i) => {
                        const bulletsClasses = (i === index) ? "carousel-bullets carousel-bullets--current" : "carousel-bullets";
                        return (
                            <span key={'b' + i} className={bulletsClasses} aria-current={i === index}></span>
                        );
                    })}
                </div>
                <button className="carousel-controls--button carousel-controls--button-next" onClick={handleNextView}>
                    <svg role="img" id="Arrow_next" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 29.4 25.3">
                        <title>afficher la vue suivante</title>
                        <path id="Arrow" d="M16.8,0l-2.2,2.2,8.9,8.9H0v3.1h23.6l-8.9,8.9,2.2,2.2,12.6-12.6L16.8,0"/>
                    </svg>
                </button>
            </div>
        </nav>
    )
}

Controls.propTypes = {
    views: PropTypes.array.isRequired,
    index: PropTypes.number.isRequired,
    setIndex: PropTypes.func.isRequired,
    popinRef: PropTypes.object.isRequired,
    setIsPopinOpen: PropTypes.func.isRequired,
    setViewInPopin: PropTypes.func.isRequired
}

export default Controls;
